import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';

export interface Subserie {
  id?: number;
  nombre?: string;
  codigo?: string;
  serie?: Serie;
}

export interface Serie {
  id?: number;
  nombre?: string;
  codigo?: string;
}

export interface Documental {
  id?: number;
  nombre?: string;
  codigo?: string;
  subserie?: Subserie;
  expediente?: boolean;
}

export interface Documentos_Fomrulario {
  tipo_documental?: number;
  id?: number;
  tipo_documental_nombre?: "prueba"
  funciones?: Funciones[];
}

export interface Funciones {
  id?: number;
  funcion?: number;
  funcion_nombre?: string;
  requerido?: boolean | string;
}

@Injectable()
export class DocumentFormDataService {

  constructor (
    private http: HttpClient,
    private api: EndpointService
  ) { }

  /**
   * Consultar todos los tipos documentales
   *
   * @returns {Observable<Documental[]>}
   * @memberof ConsecutiveManagementDatService
   */
  getTypeDocumentary(): Observable<Documental[]> {
    return new Observable(obs => {
      this.http.get<Documental[]>(this.api.get('adminTypeDocumentSpecial')).subscribe(
        typeDocumentary => {
          obs.next(typeDocumentary);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   *Obtiene los tipos de funciones
   *
   * @return {*}  {Observable<Documental[]>}
   * @memberof DocumentFormDataService
   */
  getFunctions(): Observable<Documental[]> {
    return new Observable(obs => {
      this.http.get<Documental[]>(this.api.get('defaultFunction')).subscribe(
        typeDocumentary => {
          obs.next(typeDocumentary);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/document-form/shared/document-form-component.data.service.ts